<template>
	<div>
		<div style="margin-bottom: 18px;margin-top: 18px;">
			<el-input v-model="title" placeholder="请输入菜单标题" suffix-icon="el-icon-search" style="width: 200px;"
				size="small" @keyup.enter.native="getData"></el-input>

			<el-button type="primary" style="margin-left: 15px;" size="small" @click="getData">查询</el-button>
			<el-button type="success" style="margin-left: 15px;" size="small" @click="reset">重置</el-button>
			<el-button type="warning" style="margin-left: 15px;" size="small" @click="add">新增</el-button>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border
			highlight-current-row height="79vh">
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="name" align="center" label="名称(中文)" width="500">
			</el-table-column>
			<el-table-column prop="nameEg" align="center" label="名称(英文)" width="500">
			</el-table-column>
			<!-- <el-table-column prop="url" align="center" label="地址">
			</el-table-column>
			<el-table-column prop="img" align="center" label="图片" width="180">
				<template slot-scope="scope">
					<el-image style="width: 50px; height: 50px" :src="scope.row.img"
						:preview-src-list="scope.row.srcList">
					</el-image>
				</template>
			</el-table-column> -->
			<!-- <el-table-column prop="sub" align="center" label="小标题(中文)" width="180">
			</el-table-column>
			<el-table-column prop="subEg" align="center" label="小标题(英文)" width="180">
			</el-table-column>
 -->
			<el-table-column prop="operate" align="center" label="操作">
				<template slot-scope="scope">
					<el-button type="success" size="small" @click="mod(scope.row)">编辑</el-button>
					<el-button type="warning" size="small" @click="check(scope.row)">查看</el-button>
					<el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row)" style="margin-left: 10px;">
						<el-button type="danger" slot="reference" size="small">删除</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>

		<div style="align-content: center;text-align: center;margin: 20px;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				:page-sizes="[2, 5, 10, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible" width="60%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="120px">


				<el-form-item label="所属类型" prop="account">
					<el-col :span="20">
						<el-select v-model="form.type" placeholder="请选择" :disabled="isNoEdit">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>

				<el-form-item label="显示样式" prop="account">
					<el-col :span="20">
						<el-select v-model="form.showType" placeholder="请选择" @change="changeShowType"
							:disabled="isNoEdit">
							<el-option v-for="item in options1" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>



				<el-form-item label="右侧列表" prop="account" v-show="isShow">
					<el-col :span="20">
						<el-select v-model="form.rightList" filterable multiple placeholder="请选择" :disabled="isNoEdit">
							<el-option v-for="item in options2" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>

				<el-form-item label="标题(中文)" prop="subTitle">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.subTitle" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>
				<el-form-item label="标题(英文)" prop="subTitleEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.subTitleEg" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="名称(中文)" prop="name">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.name" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>
				<el-form-item label="名称(英文)" prop="nameEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.nameEg" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="左边地址" prop="sub">
					<el-col :span="20">
						<el-input v-model="form.url" :disabled="isNoEdit"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="中间图片" prop="url">
					<el-col :span="20">
						<!-- <el-input v-model="form.remark"></el-input> -->

						<img :src="form.midelImage" class="avatar" v-if="isNoEdit">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" v-else
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled = "isUpload">
							<img v-if="form.midelImage" :src="form.midelImage" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<span  class="loading" v-if="dialogVisible">上传中...</span>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item label="中间地址" prop="sub">
					<el-col :span="20">
						<el-input v-model="form.midelUrl" :disabled="isNoEdit"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="中间标题(中文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.midelTitle" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="中间标题(英文)" prop="contentEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.midelTitleEg" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="中间内容(中文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.midelcontent" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="中间内容(英文)" prop="contentEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.midelcontentEg" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="右边标题(中文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.rightTitle" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="右边标题(英文)" prop="contentEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.rightTitleEg" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="右边内容(中文)" prop="content" v-show="isShow2">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.rightContent" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<el-form-item label="右边内容(英文)" prop="contentEg" v-show="isShow2">
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.rightContentEg" :init="initEditor" :disabled="isNoEdit" />
					</el-col>
				</el-form-item>

				<!-- <el-form-item label="图片" prop="url">
					<el-col :span="20">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<img v-if="form.img" :src="form.img" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-col>
				</el-form-item> -->

			</el-form>
			<span slot="footer" class="dialog-footer" v-show="!isNoEdit">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	export default {
		name: "UserMange",
		components: {
			TinymceEditor
		},
		data() {
			return {
				rules: {
					title: [{
						required: true,
						message: '请输入名字',
						trigger: 'blur'
					}]
				},
				options: [{
					value: 1,
					label: '行业应用'
				}, {
					value: 2,
					label: '产品'
				}, {
					value: 3,
					label: '资源'
				}, {
					value: 4,
					label: '关于我们'
				}],
				options1: [{
					value: 1,
					label: '样式一'
				}, {
					value: 2,
					label: '样式二'
				}, {
					value: 3,
					label: '样式三'
				}, {
					value: 4,
					label: '样式四'
				}],
				options2: [],
				tableData: [],
				pageSize: 10,
				page: 1,
				total: 0,
				title: "",
				centerDialogVisible: false,
				form: {
					type: "",
					subTitle: "",
					subTitleEg: "",
					nameEg: "",
					name: "",
					url: "",
					midelImage: "",
					midelUrl: "",
					midelTitle: "",
					midelTitleEg: "",
					midelcontent: "",
					midelcontentEg: "",
					rightTitle: "",
					rightTitleEg: "",
					showType: "",
					rightList: [],
					rightContent: "",
					rightContentEg: ""
				},
				btnText: "提 交",
				textTitle: "新增头部菜单",
				isDis: false,
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				fileList: [],
				fileList1: [],
				imageUrl: '',
				isShow: false,
				isShow1: false,
				isShow2: false,
				isNoEdit: false,
				dialogVisible:false,
				isUpload:false
			}
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},
		beforeMount() {
			// this.utils.Logger("1111111111111111");
			this.getData();
			// this.loadPost();
		},
		methods: {
			deleteRow(row) {
				var that = this;
				this.utils.requestPost(this, "/headerMenu/delete", {
					'id': row.id
				}, function(res, total) {
					that.getData();
					that.utils.showMessage("success", "删除成功");
				});
			},
			changeShowType(index) {
				if (index == 1) {
					this.isShow = true;
					this.isShow1 = false;
					this.isShow2 = false;
					this.getSelectList(1);
				} else if (index == 2) {
					this.isShow = true;
					this.isShow1 = false;
					this.isShow2 = false;
					this.getSelectList(2);
				} else if (index == 3) {
					this.isShow = false;
					this.isShow1 = true;
					this.isShow2 = true;
				} else if (index == 4) {
					this.isShow = true;
					this.isShow1 = false;
					this.isShow2 = false;
					this.getSelectList(4);
				}
			},
			getSelectList(type) {
				var that = this;
				var params = {
					"pageSize": 100,
					"pageNum": 1,
					"param": {
						"type": type + ""
					}
				};
				this.utils.requestPost(this, "/subList/getDataList", params, function(res, total) {
					that.options2 = [];
					for (var i = 0; i < res.length; i++) {
						var bean = {};
						bean.label = res[i].sub;
						bean.value = res[i].id;
						that.options2.push(bean);
					}
				});
			},
			handleAvatarSuccess(res, file) {
				this.form.midelImage = "https://image.sxsla.cn/files/" + res.data.name;
				this.dialogVisible = false;
				this.isUpload = false;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 20;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 20MB!');
				}
				this.dialogVisible = true;
				this.isUpload = true;
				return isLt2M;
			},
			mod(row) {
				this.form = row;
				this.btnText = "保存";
				this.textTitle = '修改菜单信息'
				this.centerDialogVisible = true;
				this.isNoEdit = false;
				this.changeShowType(row.showType);
			},
			check(row) {
				this.form = row;
				this.textTitle = '查看详情'
				this.centerDialogVisible = true;
				this.isNoEdit = true;
				this.changeShowType(row.showType);
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			save() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.form.rightList = this.form.rightList != null ? this.form.rightList.join(',') : "";
						if (that.btnText == "提交") {
							this.utils.requestPost(this, "/headerMenu/add", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "创建成功");
							});
						} else {
							this.utils.requestPost(this, "/headerMenu/mod", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "修改成功");
							});
						}
					} else {
						that.utils.showMessage("error", "请输入正确的内容");
						return false;
					}
				});

			},
			add() {
				var that = this;
				this.btnText = "提交";
				this.textTitle = '添加头部菜单'
				this.isNoEdit = false;
				this.centerDialogVisible = true;
				this.form = {
					type: "",
					subTitle: "",
					subTitleEg: "",
					nameEg: "",
					name: "",
					url: "",
					midelImage: "",
					midelUrl: "",
					midelTitle: "",
					midelTitleEg: "",
					midelcontent: "",
					midelcontentEg: "",
					rightTitle: "",
					rightTitleEg: "",
					showType: "",
					rightList: [],
					rightContent: "",
					rightContentEg: ""
				};
				this.$nextTick(() => {
					that.resetForm();
				})
			},
			reset() {
				this.name = "";
			},
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
			getData() {
				var that = this;
				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.title
					}
				};
				// this.utils.requestPost(this, "/headerMenu/getMenuDataList", params, function(res, total) {
				this.utils.requestPost(this, "/headerMenu/getDataList", params, function(res, total) {
					that.tableData = res;
					for (var i = 0; i < that.tableData.length; i++) {
						that.tableData[i].rightList = that.tableData[i].rightList.split(",");
						for (var j = 0; j < that.tableData[i].rightList.length; j++) {
							that.tableData[i].rightList[j] = parseInt(that.tableData[i].rightList[j]);
						}
					}
					that.total = total;
				});
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	
	.loading{
		width: 178px;
		height: 178px;
		margin-top: -178px;
		display: flex;
		color: #000;
		justify-content: center;
		align-items: center;
		background-color: #8c939d; 
		opacity: 0.8;
	}
	
</style>
